import React, {useState, useEffect} from 'react';
// component
import {DetailQna} from 'admin/section';
import {AdminForm,AdminSection, InputText,InputMultiImages, InputTextArea, InputSaveBtn, DataList, DataListQna} from 'admin/components';
import {BtnIcon} from 'components/btns';
import {Loading, Empty} from 'components/items';
import {alertDone, alertDelete} from 'function/alert';

// image
import ic_plus from 'image/icon/ic_plus_w.svg';
// firebase
import firebase from 'library/firebase-config.js';
import 'firebase/firestore';
import 'firebase/storage';
import InputSelection from '../components/InputSelection';
const db = firebase.firestore();
const fb_storage = firebase.storage();

const FORMINIT = {
  title: "",
	text: '',
	images: [],
	timestamp: null
}

const AdminBoard = (props) => {
	const [data, setData] = useState([]);
	const [category, setCategory] = useState([]);
	const [nowForm, setNowForm] = useState(FORMINIT);
	const [isFloating, setIsFloating] = useState(false);
	const [deleteImage, setDeleteImage] = useState([]);
	const [nowDbId, setNowDbId] = useState();
	const [nowData, setNowData] = useState({comment: []});
	const [isQna, setIsQna] = useState(false);
	const [isFaq, setIsFaq] = useState(false);
	const COLLECTION = `${props.collection}_${props.doc}`;
	const [isLoading, setIsLoading] = useState(true);
	const [imageLabel] = useState('파일 첨부');
	const [imageFile, setImageFile] = useState([]);

	useEffect(()=> {
		if(props.doc === "qna"){
			setIsQna(true);
		}else{
			setIsQna(false);
		}
		if(props.doc === 'faq'){
			setIsFaq(true)
		}else{
			setIsFaq(false)
		}
	},[props])

	useEffect(()=> {
		data.forEach(data => {
			if(data.id === nowDbId) setNowData(data);
		})
	}, [nowDbId, data])

	useEffect(() => {
		// method
		const _get = async () => {
			setIsLoading(true);
			const getData = await db.collection(COLLECTION).orderBy("timestamp", "desc").get();
			const dum = [];
			getData.docs.forEach(doc => {
				dum.push({
					...doc.data(), 
					id: doc.id
				});
			})
			setData(dum);
			setIsLoading(false);
		}
		_get();

		if(COLLECTION==="customer_faq"){
			const _getFaqCategory = async ()=> {
				const getData = await db.collection(COLLECTION).doc('category').get();
				setCategory(getData.data().data)
			}
			_getFaqCategory();
		}
	}, [COLLECTION])

	const updateComment = (comment) => {
		setNowData({
			...nowData,
			comment: [...nowData.comment, comment]
		})
	}
	// handler
  const handleFloatingClick = () => {
		if(isFloating){
			setImageFile([]);
			setDeleteImage([])
			if(isFaq){
				setNowForm({...FORMINIT, category: ''})
			}else{
				setNowForm(FORMINIT);
			}
		}
    setIsFloating(!isFloating);
	}
	const handleTextChange = (e) => {
		const {name, value} = e.target;
		setNowForm({
			...nowForm,
			[name] : value
		});
	}
	const handleTextareaChange = (e) => {
		const {name, value} = e.target;
		setNowForm({
			...nowForm,
			[name] : value
		});
	}

	const handeSelectionChange = (e) => {
		const {name, value} = e.target;
		setNowForm({
			...nowForm,
			[name] : value
		});
	}
	const handleFileChange = async  (e) => {

		if(e.target.files&&e.target.files[0]){
      if(e.target.files[0].type !== 'image/png' && e.target.files[0].type !== 'image/jpeg'){
        alert('jpeg 또는 png 파일만 업로드 가능합니다. ')
        return 
      }
			const file = e.target.files[0];

			setImageFile([...imageFile, file]);
			const reader = new FileReader();

			reader.onload =  (e) =>  {
				setNowForm({
					...nowForm,
					images: [...nowForm.images, {
						imageName: file.name,
						imageUrl: e.target.result,
					}],
				});
			}
      reader.readAsDataURL(e.target.files[0]);
			
		}
	}
	const handleFormSubmit = async (e) => {
		e.preventDefault();

		if(!nowDbId){
			if(checkForm()){
				setIsLoading(true);
				await uploadForm();
				setIsLoading(false);
				alertDone();
			}else{
				alert('형식을 모두 채워주세요.')
			}
		}else{
			setIsLoading(true);

			await updateData();

			if(deleteImage){
				deleteImage.forEach(root => {
					fbDeleteImage(root);
				})
			}

			setIsLoading(false);
			alertDone();
		}
	}
	const handleListClick =(id) => {
		setNowDbId(id);
	}
	const handleEditClick = (id) => {
		setNowDbId(id);
    data.forEach(m => {
      if(m.id === id){
        setNowForm({...m});
				setIsFloating(true);
      }
    })
	}
	const handleDeleteClick = async (id) => {
		if(alertDelete()){
			data.forEach(el => {
				if(el.id===id){
					el.images.forEach(img => {
						fbDeleteImage(img.rootPath);
					})
				}
			})
			await fbDeleteDb(id);
			setNowDbId(null);	
		}
		
	}
	const handleDeleteImageClick = (img) => {
		setNowForm({
			...nowForm,
			images : nowForm.images.filter(el => {
				return el !== img;
			})
		})

		if(img.rootPath){
			setDeleteImage([...deleteImage, img.rootPath]);
		}
	}

	// data
	const uploadForm = async () => {
		let url;
		if(imageFile[0]){
			url = await Promise.all(
				imageFile.map(img => {
					return fbUploadStorage(dbRoot(nowForm),img)
				})
			)
		}

		const newForm = {...nowForm};
		newForm.images.forEach((img,index) => {
      img.imageUrl = url[index];
      img.rootPath = `${dbRoot(nowForm)}/${img.imageName}`;
		})
		
		await fbUploadDb(newForm)
	}

	const uploadDataState = (form)=> {
    const newData = data;
    newData.unshift(form);
	}

	const updateDataState = (id, form) => {
		setData(data.map(m => {
      if(m.id === id){
        return m = form;
      }else{
        return m
      }
    }))
	}
	const updateData = async () => {
		// fb download link
		let url=null;

		if(imageFile[0]){
			url = await Promise.all(
				imageFile.map(img => {
					return fbUploadStorage(dbRoot(nowForm),img)
				})
			)
		}

		const newForm = {...nowForm};

		// 이미지 업로드 일때

		if(url){
			newForm.images.forEach((img,index) => {

				if(index>newForm.images.length-url.length-1){
					const numb = index-(newForm.images.length-url.length);
					img.imageUrl = url[numb];
					img.rootPath = `${dbRoot(nowForm)}/${img.imageName}`;
				}else{
					console.log('else')
					
				}

			})
		}
		await fbUpdateDb(newForm);
	}


	// firebase
	const fbUploadStorage = async (root, file) => {
		const storageRef = fb_storage.ref(`${root}/${file.name}`);
		await storageRef.put(file);
    return storageRef.getDownloadURL();
	}
	const fbUploadDb = async (form) => {
		try  {
			const date = new Date();

			const newForm = {
				...form,
				uploadDate: `${date.getFullYear()}.${date.getMonth()+1}.${date.getDate()}`,
				timestamp: firebase.firestore.FieldValue.serverTimestamp()
			}

      const docRef = await db.collection(COLLECTION).add(newForm)

      uploadDataState({
        ...newForm,
				id: docRef.id,
			});
			
			if(isFaq){
				setNowForm({...FORMINIT, category: ''})
			}else{
				setNowForm(FORMINIT);
			}

			setImageFile([]);
			setDeleteImage([]);
			
			setIsFloating(false);
    } catch(e) {
      console.log(e)
    }
	}
	const fbUpdateDb = (form) => {
		console.log(form);
		db.collection(COLLECTION).doc(nowDbId).set(form)
		.then(function() {
			console.log("Document successfully written!");
			updateDataState(nowDbId, nowForm);
			setNowDbId(null);
			setImageFile([]);
			setDeleteImage([]);
			setIsFloating(false);
			
			if(isFaq){
				setNowForm({...FORMINIT, category: ''})
			}else{
				setNowForm(FORMINIT);
			}
		})
		.catch(function(error) {
			console.error("Error writing document: ", error);
		});
  }
	const fbDeleteImage = (root) => {
		var desertRef = fb_storage.ref().child(root);
		desertRef.delete().then(()=> {
			console.log('image file delete')
		}).catch(err => {
			console.log(err);
		})
	}
	const fbDeleteDb = async (id) => {
		try{
      await db.collection(COLLECTION).doc(id).delete();
      
			if(isFaq){
				setNowForm({...FORMINIT, category: ''})
			}else{
				setNowForm(FORMINIT);
			}
      setData(data.filter(el=> {
        return el.id !== id
			}))
    }
    catch(e){
      console.log(e);
    }
	}

	// state


	// etc
	const checkForm = () => {
    // check form filled
    let result = true;
    Object.keys(FORMINIT).forEach(key => {
      if(FORMINIT[key] === nowForm[key]){
        if(key !== 'timestamp' && key !=="text" && key !=="images"){
          result = false;
          return;
        }
      }
    })
    return result;
	}
	
	const dbRoot = form => {
		return `${props.collection}_${props.doc}/${form.title}`
	}

	return (
		<div className="AdminBoard">
			<div className={`${isLoading ? "" : "hide"} wrap-inner-loading`}>
        <Loading />
      </div>

			{/* floating add btn */}
			{!isQna 
			? <BtnIcon className={`btn-floating admin ${isFloating ? `rotate` : ""}`}btn-add-member image = {ic_plus} onClick = {handleFloatingClick}/>
			: ""}

			{/* admin form */}
			<div className={`dim about-member-dim ${isFloating ? `active` : ""}`}></div>
			<AdminForm title={`${props.name} 추가`} onSubmit = {handleFormSubmit} className={isFloating ? 'active' : ""} handleFloatingClick = {handleFloatingClick} >
				<InputText label = {'제목'} name = {'title'} placeholder = {'제목'} value = {nowForm.title} onChange = {handleTextChange} focuse  = "true" />
				<InputTextArea label = {`내용`} name = "text" placeholder = "내용" value = {nowForm.text} onChange = {handleTextareaChange} />
				{ props.doc !== "faq"
				? <InputMultiImages  label = {`이미지`} imageLabel = {imageLabel}  name = {`imageName`} onChange = {handleFileChange} images = {nowForm.images} handleDeleteImageClick = {handleDeleteImageClick}  />
				: ""}
				{props.collection==="customer" && props.doc === "faq"
				? <InputSelection label = {'카테고리'} name = "category" placeholder = "카테고리" value = {nowForm.category} onChange={handeSelectionChange} option={category}/>
				: "" }
				<InputSaveBtn text = "저장"/>
			</AdminForm>

			{/* list */}
			<AdminSection>
				<ul>
					{!data[0]
					?<Empty text = "데이터가 존재하지 않습니다."/>
					:data.map(data => {
						return isQna
						? <DataListQna lnb = {props.doc} data = {data} key = {data.id} handleDeleteClick = {handleDeleteClick} handleListClick = {handleListClick}/> 
						: <DataList lnb = {props.doc} data = {data} key = {data.id} handleDeleteClick = {handleDeleteClick} handleEditClick = {handleEditClick}/>
					})}
				</ul>
			</AdminSection>
			
			<DetailQna className={isQna&&nowDbId ? `active` : ""} updateComment = {updateComment} handleDeleteClick  = {handleDeleteClick} back = {setNowDbId} data= {nowData} />

		</div>
	);
}


export default AdminBoard;